import React, {useEffect, useState} from 'react';
import {observer} from "mobx-react";
import {useStores} from "../stores/Context";
import {Draggable, Droppable} from "react-beautiful-dnd";
import ModalPrimary from "../boiteAOutils/ModalPrimary";
import DragDropSvg from "../boiteAOutils/SVG/DragDropSvg";
import CroixSvg from "../boiteAOutils/SVG/CroixSvg";
import CorbeilleSvg from "../boiteAOutils/SVG/CorbeilleSvg";
import CarreFlecheSortante from "../boiteAOutils/SVG/CarreFlecheSortante";
import BtnOrange from "../boiteAOutils/BtnOrange";
import PhidgetSvg from "../boiteAOutils/SVG/PhidgetSvg";
import FlecheRevenirSvg from "../boiteAOutils/SVG/FlecheRevenirSvg";
import PlusSvg from "../boiteAOutils/SVG/PlusSvg";
import ParametreSvg from "../boiteAOutils/SVG/ParametreSvg";
import WidgetMessagesInterServicesSvg from "../boiteAOutils/SVG/TypeWidget/WidgetMessagesInterServicesSvg";
import WidgetPlanningActionsSvg from "../boiteAOutils/SVG/TypeWidget/WidgetPlanningActionsSvg";
import WidgetRSPSvg from "../boiteAOutils/SVG/TypeWidget/WidgetRSPSvg";
import WidgetRssSvg from "../boiteAOutils/SVG/TypeWidget/WidgetRssSvg";
import WidgetURLSvg from "../boiteAOutils/SVG/TypeWidget/WidgetURLSvg";
import WidgetYoutubeSvg from "../boiteAOutils/SVG/TypeWidget/WidgetYoutubeSvg";
import WidgetIndicateurSvg from "../boiteAOutils/SVG/TypeWidget/WidgetIndicateurSvg";
import WidgetDateHeureSvg from "../boiteAOutils/SVG/TypeWidget/WidgetDateHeureSvg";
import WidgetConsignesSvg from "../boiteAOutils/SVG/TypeWidget/WidgetConsignesSvg";
import WidgetMeteoSvg from "../boiteAOutils/SVG/TypeWidget/WidgetMeteoSvg";
import WidgetTableauBlancSvg from "../boiteAOutils/SVG/TypeWidget/WidgetTableauBlancSvg";
import WidgetBibliothequeImagesSvg from "../boiteAOutils/SVG/TypeWidget/WidgetBibliothequeImagesSvg";
import Pusher from "pusher-js";
import Echo from "laravel-echo";

const DELETABLE_TYPES = [
    'WidgetDateHeure',
    'WidgetRss',
    'WidgetMeteo',
    'WidgetMessagesInterServices',
    'WidgetPlanningActions',
    'WidgetBibliothequeImages',
    'WidgetRSP',
];

const TYPE_LABELS = {
    WidgetDateHeure: 'Date et heure',
    WidgetRss: 'Flux RSS',
    WidgetMeteo: 'Météo',
    WidgetMessagesInterServices: 'Messages internes',
    WidgetPlanningActions: 'Planning d’actions',
    WidgetIndicateur: 'Indicateur',
    WidgetConsignes: 'Consignes',
    WidgetYoutube: 'YouTube',
    WidgetURL: 'Site web',
    WidgetRSP: 'Résolution de problèmes',
    WidgetTableauBlanc: 'Tableau blanc',
    WidgetBibliothequeImages: 'Bibliothèque d’images',
};

const SVG_COMPONENTS = {
    WidgetConsignes: <WidgetConsignesSvg />,
    WidgetDateHeure: <WidgetDateHeureSvg />,
    WidgetIndicateur: <WidgetIndicateurSvg />,
    WidgetMessagesInterServices: <WidgetMessagesInterServicesSvg />,
    WidgetMeteo: <WidgetMeteoSvg />,
    WidgetPlanningActions: <WidgetPlanningActionsSvg />,
    WidgetRSP: <WidgetRSPSvg />,
    WidgetRss: <WidgetRssSvg />,
    WidgetURL: <WidgetURLSvg />,
    WidgetYoutube: <WidgetYoutubeSvg />,
    WidgetTableauBlanc: <WidgetTableauBlancSvg />,
    WidgetBibliothequeImages: <WidgetBibliothequeImagesSvg />,
};

const DragGrip = () => (
    <svg width="16" height="20" viewBox="0 0 16 20" fill="none" aria-hidden="true">
        <circle cx="4" cy="4" r="1.5" fill="currentColor" />
        <circle cx="12" cy="4" r="1.5" fill="currentColor" />
        <circle cx="4" cy="10" r="1.5" fill="currentColor" />
        <circle cx="12" cy="10" r="1.5" fill="currentColor" />
        <circle cx="4" cy="16" r="1.5" fill="currentColor" />
        <circle cx="12" cy="16" r="1.5" fill="currentColor" />
    </svg>
);

const Sidebar = observer((props) => {
    const {widgetStore, uiStore, createWidgetStore, parametresStore} = useStores();
    const [phidgetsShow, setPhidgetsShow] = useState(uiStore.isPanelExtended);
    const [sidebarWidgets, setSidebarWidgets] = useState(widgetStore.widgetsAvailable);
    const [showModalDeletePhidget, setShowModalDeletePhidget] = useState({isOpen: false, phidget: ''});
    const isEditorOpen = Boolean(props.visible && uiStore.displayEditMode);

    const roleId = (() => {
        const raw = widgetStore.getCookie('currentEntrepriseInfos');
        if (!raw) return null;
        try {
            return JSON.parse(raw)?.role?.id;
        } catch (_) {
            try {
                return JSON.parse(decodeURIComponent(raw))?.role?.id;
            } catch (__) {
                return null;
            }
        }
    })();

    const availableCount = sidebarWidgets.filter(widget => !widgetStore.isWidgetPositioned(widget.idWidget)).length;
    const placedCount = sidebarWidgets.length - availableCount;

    const iconByType = (typeWidget, positioned = false) => {
        const icon = SVG_COMPONENTS[typeWidget];
        if (!icon) return null;

        return React.cloneElement(icon, {
            width: 28,
            height: 28,
            couleur: positioned ? '#8A9AA1' : '#008EC9',
        });
    };

    const handleAddForm = () => {
        setPhidgetsShow(false);
        uiStore.openCreationMode();
        createWidgetStore.resetCreateWidget();
    };

    const removeWidget = (idWidget) => {
        widgetStore.removeWidgetAvailable(idWidget);
    };

    const handleClickUpdateWidget = (idWidget, typeWidget) => {
        // Sur desktop, conserver la bibliothèque ouverte : le formulaire commun se
        // décale alors dans la zone libre à droite. Sur écran compact, la fermer
        // évite qu'elle masque le formulaire de configuration.
        const isCompactViewport = typeof window !== 'undefined'
            && window.matchMedia('(max-width: 960px)').matches;

        setPhidgetsShow(!isCompactViewport);
        uiStore.openCreationMode();
        createWidgetStore.openModificationMode(idWidget, typeWidget);
    };

    const handleParametresOpen = () => {
        setPhidgetsShow(false);
        widgetStore.saveWidgetsPosition();
        uiStore.openParametres();
        parametresStore.resetViews();
    };

    const openDeleteConfirmation = (event, widgetId) => {
        event.preventDefault();
        event.stopPropagation();
        setShowModalDeletePhidget({isOpen: true, phidget: widgetId});
    };

    const openConfiguration = (event, widget) => {
        event.preventDefault();
        event.stopPropagation();
        handleClickUpdateWidget(widget.idWidget, widget.typeWidget);
    };

    useEffect(() => {
        const sortedWidgets = [...widgetStore.widgetsAvailable].sort((first, second) => {
            const firstPositioned = widgetStore.isWidgetPositioned(first.idWidget);
            const secondPositioned = widgetStore.isWidgetPositioned(second.idWidget);

            if (firstPositioned && !secondPositioned) return 1;
            if (!firstPositioned && secondPositioned) return -1;
            return 0;
        });

        setSidebarWidgets(sortedWidgets);
    }, [widgetStore.widgetsLayout, widgetStore.widgetsAvailable]);

    useEffect(() => {
        uiStore.isPanelExtended = phidgetsShow;
        uiStore.isCreationMode = phidgetsShow ? false : uiStore.isCreationMode;
        uiStore.isConsultingMode = phidgetsShow ? false : uiStore.isConsultingMode;
        uiStore.isConsultingIndicateurWidget = phidgetsShow ? false : uiStore.isConsultingIndicateurWidget;
        uiStore.isConsultingModeMessagesInterServices = phidgetsShow ? false : uiStore.isConsultingModeMessagesInterServices;
        uiStore.isConsultingModePlanningActions = phidgetsShow ? false : uiStore.isConsultingModePlanningActions;
        uiStore.isConsultingConsignesWidget = phidgetsShow ? false : uiStore.isConsultingConsignesWidget;
        uiStore.isParametresOpen = phidgetsShow ? false : uiStore.isParametresOpen;
    }, [phidgetsShow, uiStore]);

    useEffect(() => {
        setPhidgetsShow(uiStore.isPanelExtended);
    }, [uiStore.isPanelExtended]);

    useEffect(() => {
        if (!isEditorOpen && phidgetsShow) {
            setPhidgetsShow(false);
        }
    }, [isEditorOpen, phidgetsShow]);

    useEffect(() => {
        window.Pusher = Pusher;
        const echo = new Echo({
            broadcaster: 'pusher',
            key: process.env.REACT_APP_WS_KEY,
            secret: process.env.REACT_APP_WS_SECRET,
            wsHost: process.env.REACT_APP_WS_URL,
            wsPort: 6001,
            forceTLS: true,
            encrypted: true,
            disableStats: true,
            enabledTransports: ['ws', 'wss'],
            cluster: 'eu',
        });

        echo.channel(widgetStore.idTotem + '-WidgetsAvailable_refreshChannel')
            .listen('Dashboard\\WidgetsAvailableRefreshEvent', () => {
                widgetStore.loadWidgetsAvailable().catch(() => {});
            });

        return () => echo.disconnect();
    }, [widgetStore.idTotem, props.visible]);

    const renderPhidget = (widget, index) => {
        const positioned = widgetStore.isWidgetPositioned(widget.idWidget);
        const deletable = DELETABLE_TYPES.includes(widget.typeWidget);

        return (
            <Draggable
                isDragDisabled={positioned}
                key={widget.idWidget}
                draggableId={widget.idWidget}
                index={index}
            >
                {(provided, snapshot) => (
                    <article
                        className={`phidgetCard ${positioned ? 'isPlaced' : ''} ${snapshot.isDragging ? 'isDragging' : ''}`}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={provided.draggableProps.style}
                    >
                        <div className="phidgetCardContent">
                            <span className={`phidgetIcon ${positioned ? 'isMuted' : ''}`}>
                                {iconByType(widget.typeWidget, positioned)}
                            </span>
                            <div className="phidgetCardCopy">
                                <span className="typePhidget">{TYPE_LABELS[widget.typeWidget] || 'Phidget'}</span>
                                <strong className="nomPhidget">{widget.nomWidget}</strong>
                                <span className={`phidgetAvailability ${positioned ? 'isPlaced' : ''}`}>
                                    {positioned ? 'Déjà sur le tableau' : 'Prêt à placer'}
                                </span>
                            </div>
                        </div>

                        <div className="phidgetCardTools">
                            {!positioned && (
                                <span
                                    className="phidgetDragHandle"
                                    title="Faites glisser cette carte vers le tableau"
                                    aria-hidden="true"
                                >
                                    <DragGrip />
                                </span>
                            )}
                            <button
                                type="button"
                                className={`phidgetAction ${deletable ? 'isDanger' : 'isPrimary'}`}
                                onMouseDown={(event) => event.stopPropagation()}
                                onTouchStart={(event) => event.stopPropagation()}
                                onClick={(event) => deletable
                                    ? openDeleteConfirmation(event, widget.idWidget)
                                    : openConfiguration(event, widget)}
                            >
                                {deletable ? <CorbeilleSvg width={15} height={15} /> : <CarreFlecheSortante width={14} height={14} />}
                                <span>{deletable ? 'Supprimer' : 'Configurer'}</span>
                            </button>
                        </div>
                    </article>
                )}
            </Draggable>
        );
    };

    return (
        <div id="sidebar_widgets" className={isEditorOpen ? (phidgetsShow ? 'extendPhidgets' : 'active') : ''}>
            <nav className="sidebar-origine" aria-label="Outils de l’éditeur">
                <button
                    type="button"
                    className={`sidebarRailAction ${uiStore.disableBtnBack ? 'isDisabled' : ''}`}
                    onClick={() => uiStore.retourEditeur()}
                    disabled={uiStore.disableBtnBack}
                >
                    <FlecheRevenirSvg width={30} height={28} couleur="#c9d9df"/>
                    <span>Revenir</span>
                </button>

                <button
                    type="button"
                    className={`sidebarRailAction ${uiStore.isCreationMode ? 'isActive' : ''}`}
                    onClick={handleAddForm}
                >
                    <span className="sidebarRailAdd"><PlusSvg width={22} height={22}/></span>
                    <span>Ajouter</span>
                </button>

                <button
                    type="button"
                    className={`sidebarRailAction ${phidgetsShow ? 'isActive' : ''}`}
                    onClick={() => setPhidgetsShow(!phidgetsShow)}
                    aria-expanded={phidgetsShow}
                >
                    <PhidgetSvg width={29} height={37} couleur="#c9d9df"/>
                    <span>Phidgets</span>
                </button>

                {roleId !== 4 && (
                    <button type="button" className="sidebarRailAction" onClick={handleParametresOpen}>
                        <ParametreSvg height={28} width={28} couleur="#c9d9df"/>
                        <span>Réglages</span>
                    </button>
                )}
            </nav>

            <aside id="sidebar-extension" className={`sidebar-extension ${phidgetsShow ? '' : 'hidden'}`} aria-hidden={!phidgetsShow}>
                <header className="phidgetLibraryHeader">
                    <div>
                        <span className="phidgetLibraryEyebrow">Bibliothèque</span>
                        <div className="phidgetLibraryTitleRow">
                            <h2>Mes phidgets</h2>
                            <span className="phidgetCount" aria-label={`${sidebarWidgets.length} phidgets`}>{sidebarWidgets.length}</span>
                        </div>
                    </div>
                    <button
                        type="button"
                        className="phidgetCloseButton"
                        onClick={() => setPhidgetsShow(false)}
                        aria-label="Fermer la bibliothèque de phidgets"
                    >
                        <CroixSvg width={18} height={18}/>
                    </button>
                </header>

                <section className="phidgetLibraryHint" aria-label="Mode d’emploi">
                    <span className="phidgetHintIcon"><DragDropSvg width={27} height={26} couleur="#008EC9"/></span>
                    <p><strong>Glissez-déposez</strong> un phidget disponible directement sur votre tableau.</p>
                </section>

                <div className="phidgetLibraryStats" aria-label="État des phidgets">
                    <span><i className="isAvailable"/>{availableCount} disponible{availableCount > 1 ? 's' : ''}</span>
                    <span><i className="isPlaced"/>{placedCount} sur le tableau</span>
                </div>

                <Droppable droppableId="sideBar" isDropDisabled={true}>
                    {(provided) => (
                        <div className="phidgetLibraryList" ref={provided.innerRef} {...provided.droppableProps}>
                            {sidebarWidgets.map(renderPhidget)}
                            {provided.placeholder}
                            {sidebarWidgets.length === 0 && (
                                <p className="phidgetLibraryEmpty">Aucun phidget n’est disponible pour cet écran.</p>
                            )}
                        </div>
                    )}
                </Droppable>
            </aside>

            {showModalDeletePhidget.isOpen && (
                <ModalPrimary
                    textTitle="Supprimer ce phidget ?"
                    textComment="S’il est présent sur le niveau flash, il sera également retiré du tableau."
                    textBtnValidate="Supprimer le phidget"
                    textBtnCancel="Annuler"
                    onCancel={() => setShowModalDeletePhidget({isOpen: false, phidget: ''})}
                    onValidate={() => {
                        if (showModalDeletePhidget.phidget) {
                            removeWidget(showModalDeletePhidget.phidget);
                            setShowModalDeletePhidget({isOpen: false, phidget: ''});
                        }
                    }}
                />
            )}
        </div>
    );
});

export default Sidebar;
